<div [attr.id]="owns_page_content ? 'content' : null" [class.extensible]="owns_page_content">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="page-title">
          <h1>
            {{ profile_root_title() }}
            <span class="page-title-separator">/</span>
            {{ active_section_label() }}
          </h1>
        </div>
      </div>
    </div>

    <div class="user-detail-layout">
      <nav aria-label="Secciones del perfil">
        <ul>
          @for (section of visible_user_detail_sections(); track section) {
            <li [class.active]="active_section() === section">
              <button type="button" (click)="select_section(section)">
                <span>{{ user_detail_section_enum_labels[section] }}</span>
                @if (section === user_detail_section_enum.Chats && show_chats_pending_dot()) {
                  <span class="section-pending-dot" aria-hidden="true"></span>
                }
              </button>
            </li>
          }
        </ul>
      </nav>

      <div class="user-detail-content">
        @if (user_loaded()) {
          @switch (active_section()) {
            @case (user_detail_section_enum.Personal) {
              <app-user-detail-personal-section
                [user_id]="user_id"
                [user]="user"
                [its_me]="its_me()"
                (user_updated)="apply_updated_user($event)"
              />
            }
            @case (user_detail_section_enum.Locations) {
              <app-locations-management
                [tab_layout]="true"
                [hide_title]="true"
                [relatable_type]="location_relatable_type_enum.User"
                [relatable_id]="user.id"
              />
            }
            @case (user_detail_section_enum.HolidaysEmail) {
              <app-user-detail-holidays-email-section
                [user_id]="user_id"
                [user]="user"
                [is_setup]="user.is_out_of_work_mail_setup ?? false"
                [its_me]="its_me()"
                (user_updated)="apply_updated_user($event)"
              />
            }
            @case (user_detail_section_enum.Notifications) {
              <app-user-detail-notifications-section
                [user_id]="user_id"
                [user]="user"
                [its_me]="its_me()"
                (user_updated)="apply_updated_user($event)"
              />
            }
            @case (user_detail_section_enum.Chats) {
              <app-user-detail-chats-section [user_id]="user_id" [user]="user" [its_me]="its_me()" />
            }
            @case (user_detail_section_enum.Oauth) {
              <app-user-detail-oauth-section [user_id]="user_id" [user]="user" [its_me]="its_me()" />
            }
            @case (user_detail_section_enum.Contract) {
              @let current_active_contract = active_contract();
              @if (current_active_contract !== null) {
                <app-user-detail-contract-section
                  [active_contract]="current_active_contract"
                  [user]="user"
                  [its_me]="its_me()"
                  (contract_finalized)="on_contract_finalized($event)"
                />
              }
            }
          }
        }
      </div>
    </div>
  </div>
</div>
